import React, { useEffect, useState } from 'react';
import { axiosGetWithHeader } from './axios';

export function AstrologerInfoFooter (props) {  
  const [astrologer, setAstrologer] = useState(null);
  const [astrologercontacts, setAstrologerContacts] = useState(null);

  useEffect(() => {
    getAstrologer();
    getAstrologerContacts();

    function getAstrologer() {
      axiosGetWithHeader("/astrologer/view",
        (response)=>{
          setAstrologer(response.data);
        },
        (error)=>{
          console.log(error);
          setAstrologer(null);
        }
      );
    }
  
    function getAstrologerContacts() {
      axiosGetWithHeader("/astrologer/getMobileAndEmail",
        (response)=>{
          setAstrologerContacts(response.data);
        },
        (error)=>{
          console.log(error);
          setAstrologerContacts(null);
        }
      );
    }
  }, []);

  return (
    <>
      {astrologer===null||astrologercontacts===null||props.userData===null?<></>:
        <div class="row m-0 p-2 text-info text-center border-top border-1 border-body  ">
          <div class="p-0 m-0  text-start col-5 ">
            Yawin Astro Software (www.yawinastro.com)<br/>
            {astrologer.firstName} {astrologer.lastName} ({astrologercontacts.mobile})
            </div>
          <div class="p-0 m-0 text-center col-2">
            <img src="/images/logo.png" alt="Yawin Astro"  class="p-0 logoprintstyle" />
          </div>
          <div class="p-0 m-0 text-end col-5">
            {props.userData.runningId} - {props.userData.firstName} {props.userData.lastName}<br/>
            {props.userData.fatherName}
          </div>
        </div>
      }
    </>      
  );
}
